export default {
  state: {
    isDrawer: false,
  },
  mutations: {
    SET_DRAWER(state, value) {
      state.isDrawer = value
    },
  },
  getters: {
    GET_DRAWER(state) {
      return state.isDrawer
    },
  },
}
